<template>
  <span v-if="valueIsSet(value)">
    <colored-icon
      v-if="settings.showIcon"
      class="me-1"
      :color="getColor()"
      :icon-class="getClass() + ' ' + getColorClass()"
      :shadow="false"
    ></colored-icon>
    <span v-if="settings.showText">{{ trans(`models.${resourceType}.options.${column}.${value}`) }}</span>
  </span>
  <span v-if="!valueIsSet(value) && settings.showText" class="text-muted">(leer)</span>
</template>

<script>
import ColoredIcon from '@kanrisha/components/Icons/ColoredIcon';

export default {
  components: {
    ColoredIcon,
  },
  props: {
    value: { type: [String, Array], default: '' },
    column: { type: String, default: '' },
    iconClass: { type: String, default: () => null },
    color: { type: String, default: () => null },
    resourceType: { type: String, default: () => '' },
    settings: {
      type: Object,
      default: () => ({
        showText: true,
        showIcon: true,
      }),
    },
  },
  setup(props) {
    const getClass = () => {
      let defaultClass = 'bi bi-circle-fill';

      return props.iconClass ?? props.settings.iconClass ?? defaultClass;
    };

    const getColorClass = () => {
      let color = props.color ?? props.settings.color;
      if (!color || color[0] === '#') {
        return '';
      }

      return 'text-' + color;
    };

    const getColor = () => {
      let color = props.color ?? props.settings.color;
      if (!color || color[0] !== '#') {
        return '';
      }

      return color;
    };

    const valueIsSet = (value) => {
      if (value && value.length) {
        return value[0];
      }

      return value !== null;
    };

    return {
      getClass,
      getColorClass,
      getColor,
      valueIsSet,
    };
  },
};
</script>
